var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: [_vm.$style.container, _vm.$style[_vm.variant]],
    on: {
      "click": function click($event) {
        return _vm.$emit('navigate');
      }
    }
  }, [_vm._t("default", [_c('arrow-left-icon', {
    directives: [{
      name: "fill",
      rawName: "v-fill:white",
      arg: "white"
    }]
  })])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }